module.exports = __webpack_public_path__ + "static/p7-f45c22c14a11f69d269595236a88799c.jpg";